import { lazy } from 'react';

export default {
  ui: 'hidden',
  path: 'video-monitoring',
  title: 'Video Monitoring',
  urlParams: '/:srcLeafId?',
  component: lazy(() => import('./video-monitoring')),
};
